import React from "react";
import { Modal, Button } from "react-bootstrap";
import { _t } from "../i18n/i18n";
import { useFetchParse } from "lib/hooks/useFetchParse";
import { HTMLComponent } from "lib/HTMLComponent";
import { LoadingSpinner } from "lib/Spinner";
import { DataErrorMsg } from "pages/analystDirectory/AnalystDirectory";

export const TermsOfServiceDialog = ({ show = true, domicile = "ja", lang = "ja", onAccept, onReject }) => {
  const [html, isLoading, isError] = useFetchTermsOfService(domicile, lang);
  return (
    <Modal show={show} onHide={() => null} size="xl" className="terms-dialog" scrollable={true}>
      <Modal.Header>
        <Modal.Title>{_t("Terms of service")}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {isLoading && <LoadingSpinner />}
        {isError && <DataErrorMsg />}
        <HTMLComponent html={html} className="overflow-y-auto" />
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={() => onReject()}>
          {_t("Cancel")}
        </Button>
        <Button variant="primary" onClick={() => onAccept()}>
          {_t("Accept")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

const useFetchTermsOfService = (domicile, lang) => {
  const agreementFile = agreementFiles[domicile][lang] || "nsc-terms-of-use-ja";
  const url = "/research/japi/content/Disclaimers/" + agreementFile;
  const fParser = (res) => res?.data[0]?.content;
  return useFetchParse(url, null, "GET", true, fParser);
};

// domcile -> lang -> agreement file
const agreementFiles = {
  nja: {
    en: "nhi-terms-of-use-en",
    ja: "nhi-terms-of-use-en",
  },
  ja: {
    ja: "nsc-terms-of-use-ja",
    en: "nsc-terms-of-use-en",
  },
};
